import { API_ORIGIN as BASE_URL } from "../utils/Environment";

// This runs once at app startup and overrides global fetch()
export function httpInterceptor() {
  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    try {
      const response = await originalFetch(...args);

      // Determine request URL (handles both string and Request object)
      const requestUrl = args[0] instanceof Request ? args[0].url : args[0];

      // Only trigger unauthorized event for our API requests
      const isApiRequest =
        requestUrl.startsWith(BASE_URL) || requestUrl.startsWith("/");

      // If backend says unauthorized, dispatch event
      if (isApiRequest) {
        const isUnauthorized = response.status === 401;
        let isDeletedOrInvalidFleetUser = false;
        let isLicenseAgreementNotAccepted = false;

        if (response.status === 403) {
          try {
            const errorPayload = await response.clone().json();
            const errorMessage = (errorPayload?.message || "").toLowerCase();
            isDeletedOrInvalidFleetUser =
              errorPayload?.errorCode === "NOT_A_ZONE_MANAGEMENT_USER" ||
              errorMessage.includes("not a zone management user");
            isLicenseAgreementNotAccepted =
              errorPayload?.errorCode === "FMS_LICENSE_AGREEMENT_NOT_ACCEPTED";
          } catch (parseError) {
            console.debug("403 response is not JSON", parseError);
          }
        }

        const isBillingLimitExceeded = response.status === 402;

        if (isUnauthorized || isDeletedOrInvalidFleetUser) {
          window.dispatchEvent(new Event("unauthorized"));
        } else if (isLicenseAgreementNotAccepted) {
          window.dispatchEvent(new Event("licenseAgreementRequired"));
        } else if (isBillingLimitExceeded) {
          window.dispatchEvent(new Event("billingLimitExceeded"));
        }
      }

      return response;
    } catch (error) {
      console.error("Global fetch error:", error);
      throw error;
    }
  };
}
